import Icon from '../components/Icon.vue'

Icon.register({
  link: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M326.6 185.4c59.7 59.8 58.9 155.7 0.4 214.6-0.1 0.1-0.2 0.3-0.4 0.4l-67.2 67.2c-59.3 59.3-155.7 59.3-215 0-59.3-59.3-59.3-155.7 0-215l37.1-37.1c9.8-9.8 26.8-3.3 27.3 10.6 0.6 17.7 3.8 35.5 9.7 52.7 2 5.8 0.6 12.3-3.8 16.6l-13.1 13.1c-28 28-28.9 73.7-1.2 102 28 28.6 74.1 28.7 102.3 0.5l67.2-67.2c28.2-28.2 28.1-73.8 0-101.8-3.7-3.7-7.4-6.6-10.3-8.6-3.7-2.5-6.8-8.2-6.9-12.6-0.4-10.6 3.3-21.5 11.7-29.8l21.1-21.1c5.5-5.5 14.2-6.2 20.6-1.7 6.1 4.2 15.3 12 20.5 17.2zM467.5 44.4c59.3 59.3 59.3 155.7 0 215l-37.1 37.1c-9.8 9.8-26.8 3.3-27.3-10.6-0.6-17.7-3.8-35.5-9.7-52.7-2-5.8-0.6-12.3 3.8-16.6l13.1-13.1c28-28 28.9-73.7 1.2-102-28-28.6-74.1-28.7-102.3-0.5l-67.2 67.2c-28.2 28.2-28.1 73.8 0 101.8 3.7 3.7 7.4 6.6 10.3 8.6 3.7 2.5 6.8 8.2 6.9 12.6 0.4 10.6-3.3 21.5-11.7 29.8l-21.1 21.1c-5.5 5.5-14.2 6.2-20.6 1.7-6.1-4.2-15.3-12-20.5-17.2-59.7-59.8-58.9-155.7-0.4-214.6 0.1-0.1 0.2-0.3 0.4-0.4l67.2-67.2c59.3-59.3 155.7-59.3 215 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/link.js
// module id = 1523
// module chunks = 0